package com.essntl.features.profile.domain.model

data class ProfileModel(
    val id: String,
    val firstName: String?,
    val lastName: String?,
    val email: String?,
    val phoneNumber: String?,
    val appVersion: String?,
    val role: Role?,
) {
    val initials
        get() =
            (firstName?.firstOrNull()?.uppercase() ?: "") + (lastName?.firstOrNull()?.uppercase() ?: "")

    val prettyName
        get() =
            firstName + " " + (lastName ?: "")

    enum class Role {
        User,
        Admin,
        Supervisor,
        Owner
    }

    companion object {
        val empty =
            ProfileModel(
                id = "",
                firstName = null,
                lastName = null,
                email = null,
                phoneNumber = null,
                appVersion = null,
                role = Role.User,
            )
    }
}